import React, {Fragment, useEffect, useState} from "react";
import ListItem from "@material-ui/core/ListItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import useDebounce from "../_shared/useDebounce";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    searchBar: {
        display: 'flex',
        flexDirection: 'column',
        padding: '1px0 40px',
        '& > *': {
            width: '100%'
        }
    },
    createOrgUnitButton: {
        justifyContent: 'flex-end',
        fontSize: '14px',
        whiteSpace: 'nowrap'
    },
}))
export const OrganizationUnitBrowserSearchListItem = ({
                                                          organizationUnitId,
                                                          onFilterChange
                                                      }: any) => {
    const {t} = useTranslation();
    const classes = useStyles();
    const [filter, setFilter] = useState('');
    const debouncedFilter = useDebounce(filter, 300);

    const handleFilterChange = (f: any) => {
        setFilter(f);
    }

    useEffect(() => {
        function raiseFilterChanged(f: any) {
            onFilterChange(f);
        }

        raiseFilterChanged(debouncedFilter);
    }, [debouncedFilter]);

    return (
        <Fragment>
            <ListItem className={classes.searchBar}>
                <TextField
                    variant="outlined"
                    value={filter}
                    onChange={e => handleFilterChange(e.target.value)}
                    InputProps={{
                        endAdornment: <Fragment>
                            {!!filter ?
                                <InputAdornment position="end" style={{cursor: 'pointer'}}>
                                    <ClearIcon onClick={() => handleFilterChange('')}/>
                                </InputAdornment> : null}
                            <InputAdornment position="end">
                                <SearchIcon/>
                            </InputAdornment>
                        </Fragment>
                    }}
                />
            </ListItem>
        </Fragment>
    )
}
